const config = {
  lobbyApiBaseUrl: process.env.REACT_APP_LOBBY_URL,
  backApiBaseUrl: process.env.REACT_APP_BACK_URL,
  authUrl: process.env.REACT_APP_AUTH_ROUTE,
  packFree: Number(process.env.REACT_APP_PACK_FREE),
  packBasic: Number(process.env.REACT_APP_PACK_BASIC),
  packEntrepreneur: Number(process.env.REACT_APP_PACK_ENTREPRENEUR),
  packStandard: Number(process.env.REACT_APP_PACK_STANDARD),
  packPro: Number(process.env.REACT_APP_PACK_PRO),
  packUsageBased: Number(process.env.REACT_APP_PACK_USAGE_BASED),
};

export default config;
